export enum DivisionPickupStatus {
    ChoXacNhan = 1,
    XacNhanLay = 2,
    ShipperHuy = 3,
    LayThanhCong = 4,
    DaPhanLai=5
}
